var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'shop/'+_vm.category.link,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
return [_c('a',{staticClass:"d-block w-100 clearfix cursor p-2 bg-white text-black rounded-lg overflow-hidden",attrs:{"href":href},on:{"click":navigate}},[_c('b-img-lazy',{attrs:{"src":_vm.category.imageUrl}}),_c('div',{staticClass:"w-100 pt-2"},[_c('b',[_vm._v(_vm._s(_vm.category.name))])])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }